import {
  sendSponsoredBrandClick,
  sendSponsoredBrandShow,
  SponsoredBrandGAEventData,
} from 'components/header/components/searchbar/components/brands/ga-events-brands';
import { useOnScreen } from './use-on-screen';
import React, { useEffect, useRef } from 'react';
import { trackingHelper } from '../../utils/tracking-helper';

type SponsoredBrandsEventsOptions = {
  brandRef: React.MutableRefObject<HTMLDivElement | null>;
  isInViewport: boolean;
} & SponsoredBrandGAEventData;

export const useSponsoredBrandsEvents = (options: SponsoredBrandsEventsOptions) => {
  const { brandRef, ...gaOptions } = options;
  const { contentId, isInViewport } = options;

  const isOnScreen = useOnScreen(brandRef, {
    threshold: 0.5,
  });

  const hasFiredViewEvent = useRef(false);

  useEffect(() => {
    if (isOnScreen && contentId && !hasFiredViewEvent.current && isInViewport) {
      trackingHelper.dispatchContentViewedEvent(contentId);
      sendSponsoredBrandShow(gaOptions);
      hasFiredViewEvent.current = true;
    }
  }, [contentId, gaOptions, isOnScreen, isInViewport]);

  useEffect(() => {
    if (!hasFiredViewEvent.current) return;
    hasFiredViewEvent.current = false;
  }, [contentId]);

  const handleClickEvent = (e: PointerEvent) => {
    if (!contentId || e.button === 1) return;
    trackingHelper.dispatchContentClickedEvent(contentId);
    sendSponsoredBrandClick(gaOptions);
  };

  return { handleClickEvent };
};
